interface SkeletonProps {
  className?: string;
  rounded?: string;
}

const Skeleton = ({ className = "", rounded = "rounded-md" }: SkeletonProps) => (
  <div
    className={`${rounded} bg-gradient-to-r from-ink-100 via-ink-200/60 to-ink-100 bg-[length:1000px_100%] animate-shimmer ${className}`}
  />
);

export const SkeletonStat = () => (
  <div className="bg-white border border-ink-200/70 rounded-2xl shadow-card p-5">
    <div className="flex items-center justify-between mb-3">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-5 w-5" rounded="rounded-md" />
    </div>
    <Skeleton className="h-8 w-24 mt-2" />
    <Skeleton className="h-3 w-16 mt-2" />
  </div>
);

export const SkeletonRow = () => (
  <div className="flex items-center gap-3 py-3">
    <Skeleton className="h-9 w-9" rounded="rounded-lg" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-3 w-1/3" />
      <Skeleton className="h-3 w-2/3" />
    </div>
    <Skeleton className="h-6 w-12" />
  </div>
);

export default Skeleton;
